import type {
    AnalysisOptionProject,
    AnalysisOptionTaskHistory
} from "../../analysis-process/2-option-selection/AnalysisOptions.ts";
import type {PromiseRunnerOptions} from "../../util/promises/PromiseRunner.tsx";
import {PromiseRunnerOptionsDefault} from "../../util/promises/PromiseRunner.tsx";
import {smartAtom} from "../../util/atom/SmartAtom.ts";
import {ConnectionAtomDep} from "../../common-process/1-metl-connection/MetlConnectionProperties.ts";

export interface CustomerAnalysisOptions {
    //A string representation which can be fed in to a query key
    id: string

    selectedProjects: AnalysisOptionProject
    jobDownloadStrategy: "INDIVIDUAL" | "EXPORT"
    jobDownloadRunner: PromiseRunnerOptions

    analyseTaskHistory: AnalysisOptionTaskHistory

    reportAnonymisedErrors: boolean
}

const CustomerAnalysisOptionsDefault: CustomerAnalysisOptions = {
    id: "abc",
    selectedProjects: {
        analyzeAll: true,
        analyzeAllSingleVersion: true,
        projectsToAnalyze: []
    },
    jobDownloadStrategy: "INDIVIDUAL",
    jobDownloadRunner: PromiseRunnerOptionsDefault,
    analyseTaskHistory: {
        enabled: true,
        durationToQueryInDays: 30,
        taskQueryDurationHours: 6,
        promiseRunner: PromiseRunnerOptionsDefault
    },
    reportAnonymisedErrors: true
}

export const [CustomerAnalysisOptionsAtom, CustomerAnalysisOptionsDep] = smartAtom({
    storageKey: "customer-analysis-options",
    defaultValue: CustomerAnalysisOptionsDefault,
    dependencies: [ConnectionAtomDep]
})

export function areCustomerOptionsSet(options: CustomerAnalysisOptions): boolean {
    const { projectsToAnalyze, analyzeAll } = options.selectedProjects
    if(analyzeAll) return true
    return projectsToAnalyze.length > 0 && projectsToAnalyze.some(s => s.analyzeAllVersions || s.versionsToAnalyze.length > 0)
}